// extracted by mini-css-extract-plugin
export default {"component":"GiCXL4","headline":"pf8oYf"};